import { render, staticRenderFns } from "./ScoreArchives.vue?vue&type=template&id=e79cb378&"
import script from "./ScoreArchives.vue?vue&type=script&lang=js&"
export * from "./ScoreArchives.vue?vue&type=script&lang=js&"
import style0 from "./ScoreArchives.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports